import { render, staticRenderFns } from "./OrdenGrupoFormulario.vue?vue&type=template&id=4bfdb2cf&scoped=true&"
import script from "./OrdenGrupoFormulario.vue?vue&type=script&lang=js&"
export * from "./OrdenGrupoFormulario.vue?vue&type=script&lang=js&"
import style0 from "./OrdenGrupoFormulario.vue?vue&type=style&index=0&id=4bfdb2cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfdb2cf",
  null
  
)

export default component.exports